// JavaScript to create a tooltip popup when the icon is clicked
document.addEventListener('DOMContentLoaded', function () {
  // Select the SVG container elements using their classes
  const widthInfoIcon = document.querySelector('.iC3afxTVIzCjjd1JV');
  const heightInfoIcon = document.querySelector('.i4Y3IjusDdzlg3zTP');
  const icon1 = document.querySelector('.ilvC5Cno7Fe6Yj4Fd'); // New icon 1
  const icon2 = document.querySelector('.ida2ZwqutOLKQ9jki'); // New icon 2

  // Change cursor to pointer when hovering over the tooltip icons
  [widthInfoIcon, heightInfoIcon, icon1, icon2].forEach(icon => {
    if (icon) {
      icon.style.cursor = 'pointer';
    }
  });

  // Function to convert centimeters to inches and fractions
  function cmToInchesFraction(cm) {
    const inchesTotal = cm / 2.54;
    const wholeInches = Math.floor(inchesTotal);
    const fraction = inchesTotal - wholeInches;
    const sixteenFraction = Math.round(fraction * 16);

    let fractionString = '';
    let adjustedWholeInches = wholeInches;

    if (sixteenFraction === 0) {
      fractionString = '';
    } else if (sixteenFraction === 16) {
      fractionString = '';
      adjustedWholeInches += 1;
    } else {
      fractionString = ` ${sixteenFraction}/16`;
    }

    return `${adjustedWholeInches}${fractionString}"`;
  }

  // Create a function to toggle the tooltip
  function toggleTooltip(event, message) {
    let tooltip = document.querySelector('.custom-tooltip');

    if (!tooltip) {
      // If no tooltip exists, create it
      tooltip = document.createElement('div');
      tooltip.className = 'custom-tooltip';
      tooltip.innerHTML = message; // Use innerHTML to support line breaks and formatting
      tooltip.style.position = 'absolute';
      tooltip.style.backgroundColor = '#333';
      tooltip.style.color = '#fff';
      tooltip.style.padding = '10px';
      tooltip.style.borderRadius = '5px';
      tooltip.style.zIndex = '1000';
      tooltip.style.fontSize = '13px';
      tooltip.style.boxShadow = '0px 0px 10px rgba(0,0,0,0.3)';
      tooltip.style.maxWidth = '250px'; // Adjust max-width to fit text without overflowing
      tooltip.style.wordWrap = 'break-word'; // Allow text wrapping

      // Calculate the position of the tooltip based on screen width
      const tooltipWidth = 250; // Fixed width of tooltip
      const windowWidth = window.innerWidth;
      let tooltipLeft = event.target.getBoundingClientRect().left + window.scrollX;

      // Adjust left position if tooltip would overflow screen
      if (tooltipLeft + tooltipWidth > windowWidth + window.scrollX) {
        tooltipLeft = windowWidth + window.scrollX - tooltipWidth - 10; // Adjust to the left to fit within viewport
      }

      // Set tooltip position dynamically
      tooltip.style.top = `${event.target.getBoundingClientRect().bottom + window.scrollY + 10}px`;
      tooltip.style.left = `${tooltipLeft}px`;

      document.body.appendChild(tooltip);

      // Add click event listener to close the tooltip when clicking outside of it
      document.addEventListener('click', closeTooltipOnClickOutside);
    } else {
      // If tooltip already exists, remove it
      tooltip.remove();
      document.removeEventListener('click', closeTooltipOnClickOutside);
    }

    // Prevent event bubbling so clicking the icon does not trigger document click event
    event.stopPropagation();
  }

  // Function to close tooltip if clicked outside
  function closeTooltipOnClickOutside(event) {
    const tooltip = document.querySelector('.custom-tooltip');
    if (
      tooltip &&
      !tooltip.contains(event.target) &&
      !widthInfoIcon.contains(event.target) &&
      !heightInfoIcon.contains(event.target) &&
      (!icon1 || !icon1.contains(event.target)) &&
      (!icon2 || !icon2.contains(event.target))
    ) {
      tooltip.remove();
      document.removeEventListener('click', closeTooltipOnClickOutside);
    }
  }

  // Attach click event to each info icon with its respective message
  if (widthInfoIcon) {
    widthInfoIcon.addEventListener('click', function (event) {
      const exampleCm = 61.42;
      const rangeMinCm = 41;
      const rangeMaxCm = 63;
      const exampleInches = cmToInchesFraction(exampleCm);
      const rangeMinInches = cmToInchesFraction(rangeMinCm);
      const rangeMaxInches = cmToInchesFraction(rangeMaxCm);

      toggleTooltip(event, `
        <strong>Select the range that matches your window’s width.</strong><br><br>
        For example:<br>
        - <strong>Metric:</strong> If your window measures ${exampleCm} cm, choose the range ${rangeMinCm} - ${rangeMaxCm} cm.<br>
        - <strong>Imperial:</strong> If your window measures ${exampleInches}, choose the range ${rangeMinInches} - ${rangeMaxInches}.<br><br>
        Pricing is calculated based on the selected range.
      `);
    });
  }

  if (heightInfoIcon) {
    heightInfoIcon.addEventListener('click', function (event) {
      const exampleCm = 139.85;
      const rangeMinCm = 102;
      const rangeMaxCm = 151;
      const exampleInches = cmToInchesFraction(exampleCm);
      const rangeMinInches = cmToInchesFraction(rangeMinCm);
      const rangeMaxInches = cmToInchesFraction(rangeMaxCm);

      toggleTooltip(event, `
        <strong>Choose the range that best fits your window’s height.</strong><br><br>
        For example:<br>
        - <strong>Metric:</strong> If your window is ${exampleCm} cm tall, select the range ${rangeMinCm} - ${rangeMaxCm} cm.<br>
        - <strong>Imperial:</strong> If your window is ${exampleInches} tall, select the range ${rangeMinInches} - ${rangeMaxInches}.<br><br>
        Pricing is determined by the selected height range.
      `);
    });
  }

  if (icon1) {
    icon1.addEventListener('click', function (event) {
      const exampleCm = 61.42;
      const exampleInches = cmToInchesFraction(exampleCm);

      toggleTooltip(event, `
        <strong>Enter your window’s exact width.</strong><br><br>
        - <strong>Metric:</strong> Include centimeters and millimeters (e.g., ${exampleCm} cm).<br>
        - <strong>Imperial:</strong> Include inches and fractions (e.g., ${exampleInches}).
      `);
    });
  }

  if (icon2) {
    icon2.addEventListener('click', function (event) {
      const exampleCm = 139.85;
      const exampleInches = cmToInchesFraction(exampleCm);

      toggleTooltip(event, `
        <strong>Input your window’s exact height.</strong><br><br>
        - <strong>Metric:</strong> Include centimeters and millimeters (e.g., ${exampleCm} cm).<br>
        - <strong>Imperial:</strong> Include inches and fractions (e.g., ${exampleInches}).
      `);
    });
  }
});
